
export interface SiteItem {
  siteProjectId: string;
  siteName: string;
  companyId?: string;
}



export interface FleetItem {
  assetProjectId: string;
  assetName: string;
  companyId?: string;
  parentProjectId?: string;
  siteProjectId?: string;
  description?: string;
}



export interface WorkOrderItem {
  workOrderProjectId: string;
  workOrderName: string;
  description?: string;
  companyId?: string;
  parentProjectId?: string;
  assetProjectId?: string;
}



export interface OverheadTaskItem {
  npCode: string;
  npCodeName: string;
  companyId?: string;
}

export interface ActivityTaskItem {
  activityId: string;
  activityName: string;
  description?: string;
  jobProjectId?: string;
  companyId?: string;
}

export interface JobItem {
  jobProjectId: string;
  jobName: string;
  description?: string;
  siteProjectId?: string;
}



export interface ApiError {
  message: string;
  code?: string;
  field?: string;
}

type ValidatorCallback = (error?: Error) => void;

interface ValidatorRule {
  validator: (rule: any, value: any, callback: ValidatorCallback) => void;
  trigger: string[];
}



export const COMPANY_IDS = {
  RENTAL: "13er",
  FORCE: "15fo",
} as const;

export type CompanyType = "rental" | "force";

export const createConditionalValidator = (
  condition: () => boolean,
  message: string,
  trigger: string[] = ["blur"]
): ValidatorRule => ({
  validator: (_rule: any, value: any, callback: ValidatorCallback) => {
    if (condition() && !value) {
      callback(new Error(message));
    } else {
      callback();
    }
  },
  trigger,
});

export const createNumericValidator = (
  condition: () => boolean,
  message: string,
  rangeMessage: string,
  minValue: number = 0
): ValidatorRule => ({
  validator: (_rule: any, value: any, callback: ValidatorCallback) => {
    if (condition() && (value === undefined || value === null || value === '')) {
      callback(new Error(message));
    } else if (value !== undefined && value !== null && value !== '' && value <= minValue) {
      callback(new Error(rangeMessage));
    } else {
      callback();
    }
  },
  trigger: ["blur"],
});

export const createEmailValidator = (
  condition: () => boolean,
  requiredMessage: string,
  formatMessage: string
): ValidatorRule => ({
  validator: (_rule: any, value: any, callback: ValidatorCallback) => {
    if (condition() && !value) {
      callback(new Error(requiredMessage));
    } else if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      callback(new Error(formatMessage));
    } else {
      callback();
    }
  },
  trigger: ["blur"],
});
